(function(){
  document.querySelectorAll('.t100parts[data-t100parts]').forEach(function(root){
    var notice=root.querySelector('.t100parts__notice span');
    if(notice) notice.textContent='The source material lists may omit a part-version suffix. Confirm the current DJI part/version shown in the system or on the component before ordering. If anything does not match, copy the material number and tell TJ Aerosense what happened or where the part is located. We can follow up for a photo if needed.';
    var empty=root.querySelector('[data-t100-empty] span');
    if(empty) empty.textContent='Try fewer words or a partial material number. If you still cannot identify it, send TJ Aerosense the assembly and what you can see; we can follow up for a photo if needed.';
    var help=root.querySelector('.t100parts__help');
    if(help){
      var h=help.querySelector('h2');
      var p=help.querySelector('p:not(.t100parts__kicker)');
      if(h) h.textContent='Send us the material number and repair context.';
      if(p) p.textContent='If you cannot positively identify the component, do not guess. Tell us the T100 assembly, copy the DJI material number from this lookup, and describe where the part is located or what happened. We can follow up for a photo if it will help confirm the part.';
    }
  });
})();
